module.exports = __webpack_public_path__ + "img/iso1328-2-2020_figB01_double-flank-radial-composite-deviation.326e0ca5.png";